import axios from "axios";
import request from "../../request";
import { easing } from "@mui/material";
import { generateGuestToken } from "../../utils/Publicpage";

export const CATALOGPAGE = (dispatch, id, companyid, storeid, userid) => {

    async function catalogpage() {
     const guestToken = generateGuestToken ();
        
        try {
            const data = await axios({
                method: "post",
                url: request.CATALOGPAGE,
                data: {
                    companyId: companyid ? companyid : 0,
                    customerId: userid ? userid : 0,
                    storeId: storeid,
                    categoryId: id
                },
                headers: {
                    "Authorization": `Bearer ${guestToken}`,
                },
            })
            dispatch({
                type: "CATALOG__PAGE__DATA",
                payload: data?.data
            })
        } catch (e) {
            console.log(e)
        }
    }
    catalogpage()
}

export const MOBILECATALOG = (dispatch) => {
    async function mobilecatalog() {
        try {
            const data = await axios({
                method: "get",
                url: request.MOBILECATALOGPAGE
            })
            dispatch({
                type: "MCATALOG__DATA",
                payload: data?.data
            })
        } catch (e) {
            console.log(e)
        }
    }
    mobilecatalog()
}

export const MOBILECATALOGTWO = (dispatch, el) => {
    if (!el?.id) return
    let USERID = localStorage.getItem('userid')
    let COMPANYID = localStorage.getItem('companyid')
    let STOREID = localStorage.getItem('storeid')
    const guestToken = generateGuestToken();

    async function mobilecatalogtwo() {
        try {
            const data = await axios({
                method: "post",
                url: request.MOBILECATALOGTWO,
                data: {
                    companyId: COMPANYID ? COMPANYID : 0,
                    customerId: USERID ? USERID : 0,
                    storeId: STOREID,
                    categoryId: el?.id
                },
                 headers: {
                    "Authorization": `Bearer ${guestToken}`,
                },
            })
            dispatch({
                type: "MCATALOG__DATA__TWO",
                payload: data?.data
            })
        } catch (e) {
            console.log(easing)
        }
    }
    mobilecatalogtwo()
}